module.exports = {
          srcSet: __webpack_public_path__ + "9d718d800c3416975d651bc4ab3c1524-618.png"+" 618w",
          images:[ {path: __webpack_public_path__ + "9d718d800c3416975d651bc4ab3c1524-618.png",width: 618,height: 321}],
          src: __webpack_public_path__ + "9d718d800c3416975d651bc4ab3c1524-618.png",
          toString:function(){return __webpack_public_path__ + "9d718d800c3416975d651bc4ab3c1524-618.png"},
          
          width: 618,
          height: 321
        }